import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { Result } from '@digibricks/core';
import { ESSAY_ANSWER_DRAFT_WEB_CACHED, SUBMISSION_API, SUBMISSION_WEB_CACHED } from '../data-sources';
import { AnswerType, FillInBlankGroupAnswer, MultipleChoiceAnswer, SingleChoiceAnswer, SUBMISSION_REPOSITORY, MatchingAnswerGroup, EssayDraftAnswer } from '../../core';
export var SubmissionRepository = /*#__PURE__*/function () {
  function SubmissionRepository(submissionApi, // TODO: Rework this cache question
  submissionWebCached, questionDraftCached) {
    _classCallCheck(this, SubmissionRepository);

    this.submissionApi = submissionApi;
    this.submissionWebCached = submissionWebCached;
    this.questionDraftCached = questionDraftCached;
  }

  _createClass(SubmissionRepository, [{
    key: "getMany",
    value: function () {
      var _getMany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(queryParams) {
        var responseOrError, submissions, sortedSubmissions;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.submissionApi.getSubmissions(queryParams);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", Result.fail(responseOrError.error));

              case 5:
                submissions = responseOrError.getValue(); // TODO: Remove this after MVP published

                sortedSubmissions = submissions.sort(function (instance1, instance2) {
                  return parseInt(instance2.createdAt) - parseInt(instance1.createdAt);
                });
                return _context.abrupt("return", Result.ok(sortedSubmissions));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getMany(_x) {
        return _getMany.apply(this, arguments);
      }

      return getMany;
    }()
  }, {
    key: "getById",
    value: function () {
      var _getById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        var responseOrError, submission;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.submissionApi.getById(id);

              case 2:
                responseOrError = _context2.sent;

                if (!responseOrError.isFailure) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", responseOrError);

              case 5:
                submission = responseOrError.getValue();
                return _context2.abrupt("return", Result.ok(submission));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getById(_x2) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "getActivitiesById",
    value: function () {
      var _getActivitiesById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        var responseOrError, submission;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.submissionApi.getActivitiesById(id);

              case 2:
                responseOrError = _context3.sent;

                if (!responseOrError.isFailure) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", responseOrError);

              case 5:
                submission = responseOrError.getValue();
                return _context3.abrupt("return", Result.ok(submission));

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getActivitiesById(_x3) {
        return _getActivitiesById.apply(this, arguments);
      }

      return getActivitiesById;
    }()
  }, {
    key: "grading",
    value: function () {
      var _grading = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id) {
        var responseOrError, submission;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.submissionApi.grading(id);

              case 2:
                responseOrError = _context4.sent;

                if (!responseOrError.isFailure) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", Result.fail(responseOrError.error));

              case 5:
                submission = responseOrError.getValue();
                return _context4.abrupt("return", Result.ok(submission));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function grading(_x4) {
        return _grading.apply(this, arguments);
      }

      return grading;
    }()
  }, {
    key: "submitGrade",
    value: function () {
      var _submitGrade = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(submissionId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.submissionApi.submitGrade(submissionId));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function submitGrade(_x5) {
        return _submitGrade.apply(this, arguments);
      }

      return submitGrade;
    }()
  }, {
    key: "rejectGrade",
    value: function () {
      var _rejectGrade = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(input) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.submissionApi.rejectGrade(input));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function rejectGrade(_x6) {
        return _rejectGrade.apply(this, arguments);
      }

      return rejectGrade;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(useCaseInput) {
        var responseOrError, response;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.submissionApi.update(useCaseInput);

              case 2:
                responseOrError = _context7.sent;

                if (!responseOrError.isFailure) {
                  _context7.next = 5;
                  break;
                }

                return _context7.abrupt("return", responseOrError);

              case 5:
                response = responseOrError.getValue();
                return _context7.abrupt("return", Result.ok(response));

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function update(_x7) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "getAnswers",
    value: function () {
      var _getAnswers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(useCaseInput) {
        var responseOrError, submissionAnswers;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.submissionApi.getAnswers(useCaseInput);

              case 2:
                responseOrError = _context8.sent;

                if (!responseOrError.isFailure) {
                  _context8.next = 5;
                  break;
                }

                return _context8.abrupt("return", Result.fail(responseOrError.error));

              case 5:
                submissionAnswers = responseOrError.getValue();
                return _context8.abrupt("return", Result.ok(submissionAnswers));

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getAnswers(_x8) {
        return _getAnswers.apply(this, arguments);
      }

      return getAnswers;
    }()
  }, {
    key: "createEssayAnswer",
    value: function () {
      var _createEssayAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(useCaseInput) {
        var responseOrError, response;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.submissionApi.createEssayAnswer(useCaseInput);

              case 2:
                responseOrError = _context9.sent;

                if (!responseOrError.isFailure) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt("return", Result.fail(responseOrError.error));

              case 5:
                response = responseOrError.getValue(); // TODO: Refactor this cache method.
                // const essayAnswer = EssayAnswer.fromJson({
                //   id: response.id.toString(),
                //   questionId: useCaseInput.input.questionId,
                //   sectionId: useCaseInput.input.sectionId,
                //   type: AnswerType.Essay,
                //   value: useCaseInput.input.value,
                // }).getValue();
                // this.submissionWebCached.createSubmissionAnswerCached(
                //   useCaseInput.submissionId,
                //   useCaseInput.input.sectionId,
                //   essayAnswer,
                // );

                return _context9.abrupt("return", Result.ok(response));

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function createEssayAnswer(_x9) {
        return _createEssayAnswer.apply(this, arguments);
      }

      return createEssayAnswer;
    }()
  }, {
    key: "updateEssayAnswer",
    value: function () {
      var _updateEssayAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(useCaseInput) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.submissionApi.updateEssayAnswer(useCaseInput);

              case 2:
                responseOrError = _context10.sent;

                if (!responseOrError.isFailure) {
                  _context10.next = 5;
                  break;
                }

                return _context10.abrupt("return", responseOrError);

              case 5:
                this.submissionWebCached.updateSubmissionEssayAnswerCached(useCaseInput.submissionId, useCaseInput.id, useCaseInput.input.value.text);
                return _context10.abrupt("return", Result.ok());

              case 7:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function updateEssayAnswer(_x10) {
        return _updateEssayAnswer.apply(this, arguments);
      }

      return updateEssayAnswer;
    }()
  }, {
    key: "createSingleChoiceAnswer",
    value: function () {
      var _createSingleChoiceAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(useCaseInput) {
        var responseOrError, response, singleChoiceAnswer;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.submissionApi.createSingleChoiceAnswer(useCaseInput);

              case 2:
                responseOrError = _context11.sent;

                if (!responseOrError.isFailure) {
                  _context11.next = 5;
                  break;
                }

                return _context11.abrupt("return", Result.fail(responseOrError.error));

              case 5:
                response = responseOrError.getValue();
                singleChoiceAnswer = SingleChoiceAnswer.fromJson({
                  id: response.id.toString(),
                  questionId: useCaseInput.input.questionId,
                  sectionId: useCaseInput.input.sectionId,
                  type: AnswerType.SingleChoice,
                  value: useCaseInput.input.value
                }).getValue();
                this.submissionWebCached.createSubmissionAnswerCached(useCaseInput.submissionId, useCaseInput.input.sectionId, singleChoiceAnswer);
                return _context11.abrupt("return", Result.ok(response));

              case 9:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function createSingleChoiceAnswer(_x11) {
        return _createSingleChoiceAnswer.apply(this, arguments);
      }

      return createSingleChoiceAnswer;
    }()
  }, {
    key: "updateSingleChoiceAnswer",
    value: function () {
      var _updateSingleChoiceAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(useCaseInput) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.submissionApi.updateSingleChoiceAnswer(useCaseInput);

              case 2:
                responseOrError = _context12.sent;

                if (!responseOrError.isFailure) {
                  _context12.next = 5;
                  break;
                }

                return _context12.abrupt("return", responseOrError);

              case 5:
                this.submissionWebCached.updateSubmissionSingleChoiceAnswerCached(useCaseInput.submissionId, useCaseInput.id, useCaseInput.input.value.answerId);
                return _context12.abrupt("return", Result.ok());

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function updateSingleChoiceAnswer(_x12) {
        return _updateSingleChoiceAnswer.apply(this, arguments);
      }

      return updateSingleChoiceAnswer;
    }()
  }, {
    key: "createMultipleChoiceAnswer",
    value: function () {
      var _createMultipleChoiceAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(useCaseInput) {
        var responseOrError, response, multipleChoiceAnswer;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.submissionApi.createMultipleChoiceAnswer(useCaseInput);

              case 2:
                responseOrError = _context13.sent;

                if (!responseOrError.isFailure) {
                  _context13.next = 5;
                  break;
                }

                return _context13.abrupt("return", Result.fail(responseOrError.error));

              case 5:
                response = responseOrError.getValue();
                multipleChoiceAnswer = MultipleChoiceAnswer.fromJson({
                  id: response.id.toString(),
                  questionId: useCaseInput.input.questionId,
                  sectionId: useCaseInput.input.sectionId,
                  type: AnswerType.MultipleChoice,
                  values: useCaseInput.input.values
                }).getValue();
                this.submissionWebCached.createSubmissionAnswerCached(useCaseInput.submissionId, useCaseInput.input.sectionId, multipleChoiceAnswer);
                return _context13.abrupt("return", Result.ok(response));

              case 9:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function createMultipleChoiceAnswer(_x13) {
        return _createMultipleChoiceAnswer.apply(this, arguments);
      }

      return createMultipleChoiceAnswer;
    }()
  }, {
    key: "updateMultipleChoiceAnswer",
    value: function () {
      var _updateMultipleChoiceAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(useCaseInput) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.submissionApi.updateMultipleChoiceAnswer(useCaseInput);

              case 2:
                responseOrError = _context14.sent;

                if (!responseOrError.isFailure) {
                  _context14.next = 5;
                  break;
                }

                return _context14.abrupt("return", responseOrError);

              case 5:
                this.submissionWebCached.updateSubmissionMultipleChoiceAnswerCached(useCaseInput.submissionId, useCaseInput.id, useCaseInput.input.values);
                return _context14.abrupt("return", Result.ok());

              case 7:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function updateMultipleChoiceAnswer(_x14) {
        return _updateMultipleChoiceAnswer.apply(this, arguments);
      }

      return updateMultipleChoiceAnswer;
    }()
  }, {
    key: "createFillInBlankAnswer",
    value: function () {
      var _createFillInBlankAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(useCaseInput) {
        var responseOrError, response, fillInBlankAnswer;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.submissionApi.createFillInBlankAnswer(useCaseInput);

              case 2:
                responseOrError = _context15.sent;

                if (!responseOrError.isFailure) {
                  _context15.next = 5;
                  break;
                }

                return _context15.abrupt("return", Result.fail(responseOrError.error));

              case 5:
                response = responseOrError.getValue();
                fillInBlankAnswer = FillInBlankGroupAnswer.fromJson({
                  id: response.id.toString(),
                  questionId: useCaseInput.input.questionId,
                  sectionId: useCaseInput.input.sectionId,
                  type: AnswerType.FillInBlank,
                  answers: [{
                    id: response.id.toString(),
                    answerBlankId: useCaseInput.input.answerBlankId,
                    value: useCaseInput.input.value
                  }]
                }).getValue();
                this.submissionWebCached.createSubmissionAnswerCached(useCaseInput.submissionId, useCaseInput.input.sectionId, fillInBlankAnswer);
                return _context15.abrupt("return", Result.ok(response));

              case 9:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function createFillInBlankAnswer(_x15) {
        return _createFillInBlankAnswer.apply(this, arguments);
      }

      return createFillInBlankAnswer;
    }()
  }, {
    key: "updateFillInBlankAnswer",
    value: function () {
      var _updateFillInBlankAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(useCaseInput) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.submissionApi.updateFillInBlankAnswer(useCaseInput);

              case 2:
                responseOrError = _context16.sent;

                if (!responseOrError.isFailure) {
                  _context16.next = 5;
                  break;
                }

                return _context16.abrupt("return", responseOrError);

              case 5:
                this.submissionWebCached.updateSubmissionFillInBlankAnswerCached(useCaseInput.submissionId, useCaseInput.id, useCaseInput.input.value);
                return _context16.abrupt("return", Result.ok());

              case 7:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function updateFillInBlankAnswer(_x16) {
        return _updateFillInBlankAnswer.apply(this, arguments);
      }

      return updateFillInBlankAnswer;
    }()
  }, {
    key: "createMatchingAnswer",
    value: function () {
      var _createMatchingAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(useCaseInput) {
        var responseOrError, response, matchingAnswer;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.submissionApi.createMatchingAnswer(useCaseInput);

              case 2:
                responseOrError = _context17.sent;

                if (!responseOrError.isFailure) {
                  _context17.next = 5;
                  break;
                }

                return _context17.abrupt("return", Result.fail(responseOrError.error));

              case 5:
                response = responseOrError.getValue();
                matchingAnswer = MatchingAnswerGroup.fromJson({
                  id: response.id.toString(),
                  questionId: useCaseInput.input.questionId,
                  sectionId: useCaseInput.input.sectionId,
                  type: AnswerType.Matching,
                  answers: [{
                    id: response.id.toString(),
                    subQuestionId: useCaseInput.input.subQuestionId,
                    value: useCaseInput.input.value
                  }]
                }).getValue();
                this.submissionWebCached.createSubmissionAnswerCached(useCaseInput.submissionId, useCaseInput.input.sectionId, matchingAnswer);
                return _context17.abrupt("return", Result.ok());

              case 9:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function createMatchingAnswer(_x17) {
        return _createMatchingAnswer.apply(this, arguments);
      }

      return createMatchingAnswer;
    }()
  }, {
    key: "updateMatchingAnswer",
    value: function () {
      var _updateMatchingAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(useCaseInput) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this.submissionApi.updateMatchingAnswer(useCaseInput);

              case 2:
                responseOrError = _context18.sent;

                if (!responseOrError.isFailure) {
                  _context18.next = 5;
                  break;
                }

                return _context18.abrupt("return", responseOrError);

              case 5:
                this.submissionWebCached.updateSubmissionMatchingAnswerCached(useCaseInput.submissionId, useCaseInput.id, useCaseInput.input.value);
                return _context18.abrupt("return", Result.ok());

              case 7:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function updateMatchingAnswer(_x18) {
        return _updateMatchingAnswer.apply(this, arguments);
      }

      return updateMatchingAnswer;
    }()
  }, {
    key: "updateAnswer",
    value: function () {
      var _updateAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(useCaseInput) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.submissionApi.updateAnswer(useCaseInput);

              case 2:
                responseOrError = _context19.sent;

                if (!responseOrError.isFailure) {
                  _context19.next = 5;
                  break;
                }

                return _context19.abrupt("return", responseOrError);

              case 5:
                return _context19.abrupt("return", Result.ok(responseOrError.getValue()));

              case 6:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function updateAnswer(_x19) {
        return _updateAnswer.apply(this, arguments);
      }

      return updateAnswer;
    }()
  }, {
    key: "getSubmissionsResponder",
    value: function () {
      var _getSubmissionsResponder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(queryParams) {
        var responseOrError, submissions, sortedSubmissions;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this.submissionApi.getSubmissionsResponder(queryParams);

              case 2:
                responseOrError = _context20.sent;

                if (!responseOrError.isFailure) {
                  _context20.next = 5;
                  break;
                }

                return _context20.abrupt("return", responseOrError);

              case 5:
                submissions = responseOrError.getValue(); // TODO: Remove this after MVP published

                sortedSubmissions = submissions.sort(function (instance1, instance2) {
                  return parseInt(instance2.createdAt) - parseInt(instance1.createdAt);
                });
                return _context20.abrupt("return", Result.ok(sortedSubmissions));

              case 8:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function getSubmissionsResponder(_x20) {
        return _getSubmissionsResponder.apply(this, arguments);
      }

      return getSubmissionsResponder;
    }()
  }, {
    key: "getSubmissionElapsedTime",
    value: function () {
      var _getSubmissionElapsedTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(useCaseInput) {
        var submissionId, cachedData;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                submissionId = useCaseInput.submissionId;
                cachedData = this.submissionWebCached.getElapsedTimeCached({
                  submissionId: submissionId
                });
                return _context21.abrupt("return", Result.ok(cachedData));

              case 3:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function getSubmissionElapsedTime(_x21) {
        return _getSubmissionElapsedTime.apply(this, arguments);
      }

      return getSubmissionElapsedTime;
    }()
  }, {
    key: "setSubmissionElapsedTime",
    value: function () {
      var _setSubmissionElapsedTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(useCaseInput) {
        var submissionId, elapsedTime;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                submissionId = useCaseInput.submissionId, elapsedTime = useCaseInput.elapsedTime;
                this.submissionWebCached.setElapsedTimeCached({
                  submissionId: submissionId,
                  elapsedTime: elapsedTime
                });
                return _context22.abrupt("return", Result.ok());

              case 3:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function setSubmissionElapsedTime(_x22) {
        return _setSubmissionElapsedTime.apply(this, arguments);
      }

      return setSubmissionElapsedTime;
    }()
  }, {
    key: "findDraftEssayAnswer",
    value: function () {
      var _findDraftEssayAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(params) {
        var queryString, cachedData;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                queryString = new URLSearchParams({
                  submissionId: params.submissionId,
                  questionId: params.questionId
                }).toString();
                _context23.next = 3;
                return this.questionDraftCached.findById(queryString);

              case 3:
                cachedData = _context23.sent;

                if (!cachedData.isFailure) {
                  _context23.next = 6;
                  break;
                }

                return _context23.abrupt("return", Result.fail(cachedData.error));

              case 6:
                return _context23.abrupt("return", Result.ok(cachedData.getValue()));

              case 7:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function findDraftEssayAnswer(_x23) {
        return _findDraftEssayAnswer.apply(this, arguments);
      }

      return findDraftEssayAnswer;
    }()
  }, {
    key: "updateDraftEssayAnswer",
    value: function () {
      var _updateDraftEssayAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(params) {
        var essayDraftAnswer;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                essayDraftAnswer = EssayDraftAnswer.create({
                  submissionId: params.submissionId,
                  questionId: params.questionId,
                  content: params.content
                }).getValue();
                _context24.next = 3;
                return this.questionDraftCached.create(essayDraftAnswer);

              case 3:
                return _context24.abrupt("return", Result.ok());

              case 4:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function updateDraftEssayAnswer(_x24) {
        return _updateDraftEssayAnswer.apply(this, arguments);
      }

      return updateDraftEssayAnswer;
    }()
  }, {
    key: "deleteDraftEssayAnswer",
    value: function () {
      var _deleteDraftEssayAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(params) {
        var queryString;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                queryString = new URLSearchParams({
                  submissionId: params.submissionId,
                  questionId: params.questionId
                }).toString();
                _context25.next = 3;
                return this.questionDraftCached["delete"](queryString);

              case 3:
                return _context25.abrupt("return", Result.ok());

              case 4:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function deleteDraftEssayAnswer(_x25) {
        return _deleteDraftEssayAnswer.apply(this, arguments);
      }

      return deleteDraftEssayAnswer;
    }()
  }, {
    key: "removeKeyDraftEssayAnswer",
    value: function () {
      var _removeKeyDraftEssayAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return this.questionDraftCached.deleteMany();

              case 2:
                return _context26.abrupt("return", Result.ok());

              case 3:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function removeKeyDraftEssayAnswer() {
        return _removeKeyDraftEssayAnswer.apply(this, arguments);
      }

      return removeKeyDraftEssayAnswer;
    }()
  }, {
    key: "createAnswerComment",
    value: function () {
      var _createAnswerComment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(useCaseInput) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return this.submissionApi.createAnswerComment(useCaseInput);

              case 2:
                responseOrError = _context27.sent;

                if (!responseOrError.isFailure) {
                  _context27.next = 5;
                  break;
                }

                return _context27.abrupt("return", Result.fail(responseOrError.error));

              case 5:
                return _context27.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function createAnswerComment(_x26) {
        return _createAnswerComment.apply(this, arguments);
      }

      return createAnswerComment;
    }()
  }, {
    key: "updateAnswerComment",
    value: function () {
      var _updateAnswerComment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(useCaseInput) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return this.submissionApi.updateAnswerComment(useCaseInput);

              case 2:
                responseOrError = _context28.sent;

                if (!responseOrError.isFailure) {
                  _context28.next = 5;
                  break;
                }

                return _context28.abrupt("return", Result.fail(responseOrError.error));

              case 5:
                return _context28.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function updateAnswerComment(_x27) {
        return _updateAnswerComment.apply(this, arguments);
      }

      return updateAnswerComment;
    }()
  }, {
    key: "deleteAnswerComment",
    value: function () {
      var _deleteAnswerComment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(useCaseInput) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return this.submissionApi.deleteAnswerComment(useCaseInput);

              case 2:
                responseOrError = _context29.sent;

                if (!responseOrError.isFailure) {
                  _context29.next = 5;
                  break;
                }

                return _context29.abrupt("return", Result.fail(responseOrError.error));

              case 5:
                return _context29.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function deleteAnswerComment(_x28) {
        return _deleteAnswerComment.apply(this, arguments);
      }

      return deleteAnswerComment;
    }()
  }, {
    key: "updateSpeakingAnswer",
    value: function () {
      var _updateSpeakingAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(useCaseInput) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return this.submissionApi.updateSpeakingAnswer(useCaseInput);

              case 2:
                responseOrError = _context30.sent;

                if (!responseOrError.isFailure) {
                  _context30.next = 5;
                  break;
                }

                return _context30.abrupt("return", responseOrError);

              case 5:
                return _context30.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function updateSpeakingAnswer(_x29) {
        return _updateSpeakingAnswer.apply(this, arguments);
      }

      return updateSpeakingAnswer;
    }()
  }, {
    key: "createSpeakingAnswerAttempt",
    value: function () {
      var _createSpeakingAnswerAttempt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(useCaseInput) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return this.submissionApi.createSpeakingAnswerAttempt(useCaseInput);

              case 2:
                responseOrError = _context31.sent;

                if (!responseOrError.isFailure) {
                  _context31.next = 5;
                  break;
                }

                return _context31.abrupt("return", responseOrError);

              case 5:
                return _context31.abrupt("return", Result.ok(responseOrError.getValue()));

              case 6:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function createSpeakingAnswerAttempt(_x30) {
        return _createSpeakingAnswerAttempt.apply(this, arguments);
      }

      return createSpeakingAnswerAttempt;
    }()
  }]);

  return SubmissionRepository;
}();
export var submissionRepositoryProvider = {
  provide: SUBMISSION_REPOSITORY,
  useFactory: function useFactory(submissionApi, submissionWebCached, questionDraftCached) {
    return new SubmissionRepository(submissionApi, submissionWebCached, questionDraftCached);
  },
  inject: [SUBMISSION_API, SUBMISSION_WEB_CACHED, ESSAY_ANSWER_DRAFT_WEB_CACHED]
};